<template>

  <el-row>
    <el-col :span="24">
      <table class="el-table">
        <thead>
          <th>#</th>
          <th>Sharer</th>
<!--          <th align="right">Ways</th> -->
          <th align="right">Percent</th>
          <th align="right">Sites</th>
        </thead>

        <tbody>
          <tr v-for="sharer, index in sharers">
            <td><i>{{index+1}}</i></td>
            <td><b>{{sharer.name}}</b> <small>[<span
              :class="sharer.type==='Sharer'
              ? 'text-success' : 'text-info'">
              {{sharer.type}}
            </span>]
          </small></td>
<!--          <td>{{sharer.sharedSites}}</td>  -->
          <td><b>{{formatNumber(sharer.percent, 2)}}</b>%</td>
          <td><b>{{formatNumber(sharer.sites, 0)}}</b></td>
        </tr>
      </tbody>

    </table>
  </el-col>

</el-row>

</template>


<script>

import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [NumberMixins],


  props: {

    sharerData: {
      type: Array,
      required: true
    }

  },



  watch: {
    sharerData: function (value) {
      this.processData(value)
    }
  },


  methods: {

    processData (data) {
      this.sharers = []
      this.sharers = data
    }

  },



  data () {

    return {
      sharers: null
    }

  },

  created () {
    this.processData(this.sharerData)
  }
}
</script>



// WEBPACK FOOTER //
// WaysTable.vue?09429a0c